(ns machtfit.repository.query
  (:require [machtfit.repository.core :as repository]
            [re-frame.core :as rf]))

(def ^:private db-path-queries
  (conj repository/db-path-base :queries))

(defn running? [db id]
  (get-in db (conj db-path-queries id)))

(rf/reg-event-fx ::register
  (fn [{:keys [db]} [_ id]]
    {:db (update-in db db-path-queries assoc id true)}))

(rf/reg-event-fx ::unregister
  (fn [{:keys [db]} [_ id]]
    {:db (update-in db db-path-queries dissoc id)}))
